import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { WorksheetChartSection } from 'Components/Worksheets/Core';

let Chart: React.FC = () => {
  return (
    <NamePrefixModifier namePrefix="chart">
      <WorksheetChartSection wide height={885} />
    </NamePrefixModifier>
  );
};

export { Chart };
